import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InlineSVGModule } from "ng-inline-svg-2";
import { SharedModule } from "../../../../../shared/shared.module";
import { LangSwitcherComponent } from "./lang-switcher.component";

@NgModule({
  imports: [CommonModule, InlineSVGModule, SharedModule, LangSwitcherComponent],
  exports: [LangSwitcherComponent],
})
export class LangSwitcherModule {}
